import { useState, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import Networking from "../services/Networking";

interface ISpeech {
  index: number;
  title: string;
  content: string;
  youtubeId: string;
  author: string;
}
const card: any = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "300px"
};
const iframeStyle: any = {
  objectFit: "cover" // Prevent image overflow
};
function Speech({
  index,
  title,
  content,
  youtubeId,
  author
}: ISpeech) {
  return (
    <Accordion.Item eventKey={"" + index}>
      <Accordion.Header>
        <strong>
          {[author, title].join(":")}
        </strong>
      </Accordion.Header>
      <Accordion.Body>
        {content}
        <Card style={card}>
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              className="embed-responsive-item"
              src={`https://www.youtube.com/embed/${youtubeId}`}
              title="YouTube Video"
              allowFullScreen
              style={iframeStyle}
            />
          </div>
        </Card>
      </Accordion.Body>
    </Accordion.Item>
  );
}
function BestSpeeches() {
  const [speeches, setSpeeches] = useState<any>([]);
  useEffect(() => {
    async function getInspiredTalks() {
      try {
        const res: any = await Networking.getInspiredTalks();
        if (res.success) {
          setSpeeches(res.data);
        } else {
          setSpeeches([]);
        }
      } catch (error) {
        setSpeeches(null);
      }
    }
    getInspiredTalks();
  }, []);
  return (
    <Accordion defaultActiveKey="0">
      {speeches.map((s: any, index: number) =>
        <Speech
          key={index}
          index={index}
          title={s.title}
          content={s.content}
          youtubeId={s.youtubeId}
          author={s.author}
        />
      )}
    </Accordion>
  );
}

export default BestSpeeches;
